import type { PersuadeCardInputs } from '@valk-nx/compositions/ui-persuade-card/src/lib/persuade-card.interface';

export type SortType = 'NAME_ASC' | 'NAME_DESC' | 'PRICE_ASC' | 'PRICE_DESC';

export type SortSelection = SortType | 'NONE';

const SORT_TYPES: readonly SortType[] = [
	'NAME_ASC',
	'NAME_DESC',
	'PRICE_ASC',
	'PRICE_DESC',
];

export function toSortSelection(value: string): SortSelection {
	return SORT_TYPES.find((type) => type === value) ?? 'NONE';
}

export interface SortOption {
	value: SortType;
	label: string;
}

export interface ExtendedPersuadeCardInputs extends PersuadeCardInputs {
	showDisabledText: boolean;
}
